import React from "react";
import Select from "./Select.jsx";

const TrimestreSelect = ({ value, setValue }) => {
  const defaultOption = { value: "all", label: "Todos los trimestres" };
  const options = [
    { key: "q1", value: "q1", label: "Q1" },
    { key: "q2", value: "q2", label: "Q2" },
    { key: "q3", value: "q3", label: "Q3" },
    { key: "q4", value: "q4", label: "Q4" },
  ];
  return (
    <Select
      id={"selectTrimestre"}
      name={"selectTrimestre"}
      value={value}
      setValue={setValue}
      defaultOption={defaultOption}
      options={options}
    />
  );
};

export default TrimestreSelect;
